import React, { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { IconPackages, IconHistory, IconPackageImport, IconTrash, IconFlask } from "@tabler/icons-react";
import MobileMenuButton from "../components/MobileMenuButton";
import { assembliesApi, ozonAssembliesApi } from "../api";
import { ds, menuBadgeSx } from "../theme/keeperTheme";

export default function HomeMenu() {
  const { registerToolbarRefresh } = useOutletContext() || {};
  const [assemblyOrdersCount, setAssemblyOrdersCount] = useState(undefined);

  /** Бейдж «Товары на сборку» — сумма по всем маркетплейсам (WB + Ozon). */
  const loadSummary = useCallback(() => {
    return Promise.all([
      assembliesApi
        .summary()
        .then((data) =>
          typeof data.assembly_orders_count === "number" ? data.assembly_orders_count : 0,
        )
        .catch(() => null),
      ozonAssembliesApi
        .summary()
        .then((data) => (typeof data.postings_count === "number" ? data.postings_count : 0))
        .catch(() => null),
    ]).then(([wb, ozon]) => {
      if (wb == null && ozon == null) {
        setAssemblyOrdersCount(null);
        return;
      }
      setAssemblyOrdersCount((wb || 0) + (ozon || 0));
    });
  }, []);

  useEffect(() => {
    loadSummary();
  }, [loadSummary]);

  useEffect(() => {
    if (!registerToolbarRefresh) return undefined;
    return registerToolbarRefresh(() => loadSummary());
  }, [registerToolbarRefresh, loadSummary]);

  const menuBadge =
    assemblyOrdersCount === undefined ? (
      <Box
        sx={{
          minWidth: 40,
          height: 30,
          borderRadius: 999,
          bgcolor: ds.surface3,
          border: `1px solid ${ds.border}`,
        }}
      />
    ) : assemblyOrdersCount === null ? null : (
      <Box sx={menuBadgeSx}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "0.875rem",
            color: ds.surface,
            lineHeight: 1.2,
            fontFeatureSettings: '"tnum"',
          }}
        >
          {assemblyOrdersCount}
        </Typography>
      </Box>
    );

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        bgcolor: ds.bg,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 3,
        pb: 4,
        px: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.25,
        }}
      >
        <MobileMenuButton
          to="/pick"
          label="Товары на сборку"
          icon={<IconPackages size={26} stroke={1.5} />}
          trailing={menuBadge}
        />
        <MobileMenuButton
          to="/returns"
          label="Приём возврат"
          tone="info"
          icon={<IconPackageImport size={26} stroke={1.5} />}
        />
        <MobileMenuButton
          to="/defect"
          label="Брак"
          tone="danger"
          icon={<IconTrash size={26} stroke={1.5} />}
        />
        <MobileMenuButton
          to="/history"
          label="История"
          tone="neutral"
          icon={<IconHistory size={26} stroke={1.5} />}
        />
        <MobileMenuButton
          to="/marking-test"
          label="Тест сканера"
          muted
          icon={<IconFlask size={26} stroke={1.5} />}
        />
      </Box>
    </Box>
  );
}
